import { Box, Flex, Text } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { SanityImage } from '~/components/sanity-image';

import { AboutUsTemplate } from '../model';

export function PartnerSection({ partnerCompanies }: { partnerCompanies: AboutUsTemplate['partnerCompanies'] }) {
  return (
    <Box as='section' py='40px'>
      <ContentContainer>
        <Flex alignItems='center' flexDirection={{ base: 'column', lg: 'row' }} gap={{ base: '32px', lg: '64px' }}>
          <Text as='h2'>Content co-created with</Text>
          <Flex
            alignItems='center'
            flex={1}
            flexWrap='wrap'
            gap='32px'
            justifyContent={{ base: 'center', lg: 'space-between' }}
          >
            {partnerCompanies.map((partnerCompany) => {
              if (!partnerCompany.lofiLogoDark) return null;

              const { width, height, aspectRatio } = partnerCompany.lofiLogoDark.asset.metadata.dimensions;

              return (
                <Box
                  key={partnerCompany._id}
                  height={height >= width ? '32px' : `${100 / aspectRatio}px`}
                  position='relative'
                  width={width > height ? '100px' : `${32 / aspectRatio}px`}
                >
                  <SanityImage image={partnerCompany.lofiLogoDark} style={{ objectFit: 'contain' }} fill />
                </Box>
              );
            })}
          </Flex>
        </Flex>
      </ContentContainer>
    </Box>
  );
}
